import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Device } from '@era/locations-sdk';
import { DeviceGridItemContainerComponent } from './device-grid-item.container';

@Component({
  selector: 'era-device-grid-ui',
  templateUrl: './device-grid.component.html',
  styleUrls: ['./device-grid.component.scss'],
  imports: [DeviceGridItemContainerComponent],
})
export class DeviceGridComponent {
  @Input() devices: Device[];
  @Output() readonly selected = new EventEmitter<Device>();

  public select(device: Device) {
    this.selected.emit(device);
  }
}
